import { render, staticRenderFns } from "./ReceberItem.vue?vue&type=template&id=e7993cf8"
import script from "./ReceberItem.vue?vue&type=script&lang=js"
export * from "./ReceberItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports